import Star from '@/assets/icons/Star.svg';
import type { StoreReview as Review } from '@/types';
import * as Styled from './StoreReview.styled';

interface StoreReviewProps {
  review: Review;
}

export const StoreReview = ({
  review: { date, heading, rating, review, reviewHeading },
}: StoreReviewProps) => {
  const ratingLabel = rating === 1 ? '1 star' : `${rating} stars`;
  return (
    <Styled.ReviewContainer>
      <h2>{heading}</h2>
      <Styled.Ratings>
        {Array(rating)
          .fill(null)
          .map((_, idx) => {
            // The following variable assignment is just for getting around Sonar and ESLint warnings
            // about using index as key, which is OK in this case because each element is identical.
            const key = idx;

            return (
              <Styled.Rating key={key}>
                <Star />
              </Styled.Rating>
            );
          })}
        <p className="visually-hidden">{ratingLabel}</p>
      </Styled.Ratings>
      <Styled.InnerWrapper>
        <h3>{reviewHeading}</h3>
        {/* biome-ignore lint/security/noDangerouslySetInnerHtml: we trust the source of the HTML */}
        <div dangerouslySetInnerHTML={{ __html: review }} />
      </Styled.InnerWrapper>
      <time>Date of experience: {date}</time>
    </Styled.ReviewContainer>
  );
};
